




























































































import moment from 'moment-timezone';
import { mapActions, mapGetters } from 'vuex';

import { ISystemError } from '@/models/error/error.types';
import { setErrorFromAxiosError } from '@/utils/helpers';
import { IWorkflow } from '@/models';

import mixins from '@/utils/mixins';
import Functions from '@/mixins/functions';
import auth from '@/mixins/auth';
import SnackBarMixin from '@/mixins/snackbar';

import ALPage from '@/components/core/Page/ALPage.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import WorkflowFormDialog from '@/components/workflows/WorkflowFormDialog.vue';
import WorkflowStatusDisplay from '@/components/workflows/WorkflowStatusDisplay.vue';
import WorkflowDetailOptionsButton from '@/components/workflows/WorkflowDetailOptionsButton.vue';

const baseMixins = mixins(Functions, auth, SnackBarMixin);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    workflowFormDialog: InstanceType<typeof WorkflowFormDialog>;
  };
}

export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    name: 'WorkflowListPage',

    components: {
      ALPage,
      ErrorAlert,
      WorkflowDetailOptionsButton,
      WorkflowFormDialog,
      WorkflowStatusDisplay
    },

    data() {
      return {
        loading: false,
        isSearchFilterActive: false,

        error: null as ISystemError | null,
        search: this.$route.query.search as string,

        sortBy: 'id',
        sortDesc: true,

        headers: [
          {
            text: '',
            sortable: false,
            value: 'index',
            width: 20
          },
          {
            text: 'Name',
            sortable: false,
            value: 'name'
          },

          {
            text: 'Owner',
            sortable: false,
            value: 'owner'
          },

          {
            text: 'Last Updated',
            sortable: false,
            value: 'modified'
          },

          {
            text: 'Status',
            sortable: false,
            value: 'state',
            width: 100,
            align: 'center'
          },
          {
            text: '',
            sortable: false,
            align: 'center',
            width: 100,
            value: 'actions'
          }
        ]
      };
    },

    computed: {
      ...mapGetters({
        workflows: 'workflow/getWorkflows'
      })
    },

    mounted() {
      this.loading = true;

      this.fetchWorkflows()
        .catch(error => {
          this.error = setErrorFromAxiosError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    methods: {
      moment,

      ...mapActions({
        fetchWorkflows: 'workflow/fetchWorkflows'
      }),

      clearAllErrors(): void {
        this.error = null;
      },

      goToWorkflowDetailPage(workflow: IWorkflow) {
        return this.$router.push({
          name: 'workflow-detail',
          params: {
            id: String(workflow.id)
          }
        });
      },

      openWorkflowWizard(workflow?: IWorkflow) {
        this.$refs.workflowFormDialog.open(workflow);
      }
    }
  });
